import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isApplePayAvailable } from './PaymentApi';
import appleLoader from '../assets/apple_loader.gif';

const ApplePayButtonStatus = { UNKNOWN: 0, AVAILABLE: 1, NOT_AVAILABLE: 2 };

class ApplePayButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
            applePayButtonStatus: ApplePayButtonStatus.UNKNOWN
        };
    }
    componentDidMount() {
        this.updateButtonState();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.disabled !== this.props.disabled) {
            this.updateButtonState();
        }
    }
    updateButtonState() {
        isApplePayAvailable()
            .then((canMakePayments) => {
                this.setState({
                    applePayButtonStatus: canMakePayments ? ApplePayButtonStatus.AVAILABLE : ApplePayButtonStatus.NOT_AVAILABLE
                });
            })
            .catch((err) => {
                this.setState({
                    applePayButtonStatus: ApplePayButtonStatus.NOT_AVAILABLE
                });
            });
    }

    render() {
        let getButton = () => {
            switch (this.state.applePayButtonStatus) {
                case ApplePayButtonStatus.UNKNOWN:
                    return (
                        <div className="apple-loader">
                            <img
                                src={appleLoader}
                            />
                        </div>
                    );
                case ApplePayButtonStatus.AVAILABLE:
                    return (
                        <div className="apple-container" lang="es">
                            <div
                                className={`apple-pay-button apple-pay-button-black${this.props.disabled ? ' disabled' : ''}`}
                                id="apple-pay"
                                onClick={this.props.disabled ? null : this.props.onClick}
                            ></div>
                        </div>
                    );
                case ApplePayButtonStatus.NOT_AVAILABLE:
                    return (
                        <div className="apple-container" lang="es">
                            <div
                                className={`apple-pay-button apple-pay-button-black disabled`}
                                id="apple-pay"
                                onClick={null}
                            ></div>
                        </div>
                    );
                default:
                    return <div> Invalid status!!! </div>;
            }
        };

        return <div className="row" id="apple-pay-row">{getButton()}</div>;
    }
}

ApplePayButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export default ApplePayButton;



// WEBPACK FOOTER //
// ./client/components/ApplePayButton.js